import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { RubleIcon } from "@/shared/icons";
import { SoundButton, SoundModal } from "@/shared/ui";

type Props = {
  price: number;
  onClose: () => void;
  onConfirm: () => void;
  isConfirming: boolean;
};

export default function TransportWarehouseTransportUnlockSlotModal({
  price,
  onClose,
  onConfirm,
  isConfirming,
}: Props) {
  const { t } = useTranslation("transportWarehouse");

  return (
    <SoundModal
      open
      onClose={onClose}
      className="successShadow w-[25.125rem]"
      // classNameOverlay="absolute"
      // container={TRANSPORT_WAREHOUSE_CONTAINER}
      dataMzAccent="success"
    >
      <div className="relative flex flex-col items-center">
        <div className="text-18 font-bold">{t("transportWarehouse.unlockSlot")}</div>
        <div className="h-[1px] w-[20rem] bg-[#1F1F1F]/80 flex justify-center my-5">
          <div className="h-full w-[5rem] bg-accent-muted" />
        </div>
        <div className="w-full text-16 font-medium text-center">
          {t("transportWarehouse.doYouWantUnlockSlot")}
        </div>
        <div className="flex justify-center items-center gap-2 w-full h-11 mt-3.5 mb-4 p-3.5 bg-gradient-to-b from-accent-muted/10 to-accent-muted/10 rounded-xl border border-dashed border-accent-muted">
          <p className="text-16 font-medium leading-none">
            <RubleIcon className="size-5.5 text-accent-muted" />
          </p>
          <p className="text-16 font-bold leading-none">{formatPrice(price)} ₽</p>
        </div>
        <div className="grid grid-cols-2 gap-2 w-full">
          <SoundButton className="w-full h-11" onClick={onClose} disabled={isConfirming}>
            {t("transportWarehouse.yes")}
          </SoundButton>
          <SoundButton
            className="w-full h-11"
            variant="solid-surface-gradient"
            onClick={onConfirm}
            loading={isConfirming}
            disabled={isConfirming}
          >
            {t("transportWarehouse.cancel")}
          </SoundButton>
        </div>
      </div>
    </SoundModal>
  );
}
